import { useTweaks } from '../components/Tweaks.jsx';
import { Header } from '../components/Header.jsx';
import { Footer } from '../components/Blocks.jsx';
import { IH_Hero, IH_Shapes, IH_Sprints, IH_Marathons, IH_Advice, IH_CTA } from '../components/IntensiveHub.jsx';

const TWEAK_DEFAULTS = {
  navWelshResources: 'Welsh Resources',
  navAboutUs: 'About us',
  navContact: 'Contact',
  startLearning: 'Start Learning',
  footerCta: 'Start your language learning journey today.',
  footerCol1: 'What we do',
  footerCol2: 'SaySomethingin Learners',
  footerLegal: '© 2026 SaySomethingIn Cyf. Glaslyn, Ffordd y Parc, Bangor, Gwynedd LL57 4FE, Wales.',
};

const GROUPS = [
  { name: 'Header', keys: ['navWelshResources','navAboutUs','navContact','startLearning'] },
  { name: 'Footer', keys: ['footerCta','footerCol1','footerCol2','footerLegal'], long:['footerLegal'] },
];

export default function IntensiveLearningHub() {
  const { tweaks, panel } = useTweaks({ defaults: TWEAK_DEFAULTS, groups: GROUPS });
  return (
    <div data-screen-label="Intensive Learning Hub">
      <Header t={tweaks}/>
      <main>
        <IH_Hero/>
        <IH_Shapes/>
        <IH_Sprints/>
        <IH_Marathons/>
        <IH_Advice/>
        <IH_CTA/>
      </main>
      <Footer t={tweaks} hideCta={true}/>
      {panel}
    </div>
  );
}
